import React, { useEffect, useMemo, useState } from "react";
import { jsonrepair } from "jsonrepair";
import PopMenu from "../../../components/Dialog/PopMenu";
import {
  RetriveServicecategoryService,
  RetriveServiceEditService,
  updateApiService,
  fetchVendorForAddingService,
} from "../../../services/apiaddservice";
import DivTag from "../../Components/DivComponent/DivTag";
import SelectWithLabelOption from "../../Components/SelectComponent/SelectWithLabelOption";
import InputWithLabel from "../../Components/InputComponent/InputWithLabel";
import ReactQuill from "react-quill";
import Option from "../../Components/OptionComponent/Option";
import TextAreaWithLabel from "../../Components/TextAreaWithLabel/TextAreaWithLabel";
import TextAreaWithLabel2 from "../../Components/TextAreaWithLabel/TextAreaWithLabel2";
import Button from "../../Components/ButtonComponent/Button";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import Loader from "../../../components/Loader/Loader";
import UnifiedApiParameterBuilder from "../AddService/UnifiedApiParameterBuilder";
import { Info } from "lucide-react";

const UpdatePopUp = ({ visible, onClose, selectedId }) => {
  const [value, setValue] = useState("");
  const [serviceCategoryList, setServiceCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [postUrl, setPostUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successResponse, setSuccessResponse] = useState("");
  const [requestResponse, setRequestResponse] = useState("");
  const [systemName, setSystemName] = useState("");
  const [componentKey, setComponentKey] = useState(0);
  const [preference, setPreference] = useState("");
  const [statusAdd, setStatusAdd] = useState("");
  const [vendorList, setVendorList] = useState([]);
  const [vendorId, setVendorId] = useState("");
  const [perHitCost, setPerHitCost] = useState("");
  const [keyDescription, setKeyDescription] = useState("");
  const [serviceValue, setServiceValue] = useState("");
  const [method, setMethod] = useState("");
  const [failedResponse, setFailedResponse] = useState("");
  const [activationFees, setActivationFees] = useState();
  const [isAgreementAgreed, setIsAgreementAgreed] = useState(false);
  const [adjustmentType, setAdjustmentType] = useState("");
  const [statusCode, setStatusCode] = useState("");

  const modules_quill = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      [{ color: ["#ff0000", "#00ff00", "#0000ff", "#000000"] }], // Set font color options to red, green, blue
      ["clean"],
    ],
  };
  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "color",
  ];

  useEffect(() => {
    const loadVendors = async () => {
      try {
        const res = await fetchVendorForAddingService();
        if (res?.data) {
          setVendorList(res.data || res.data.data || []);
        }
      } catch (error) {
        console.error("Vendor fetch failed:", error);
      }
    };

    loadVendors();
  }, []);

  async function RetriveServicecategory() {
    try {
      const respone = await RetriveServicecategoryService();

      if (respone.success === true) {
        setServiceCategoryList(respone.data);
        return;
      }
    } catch (error) {
      return error;
    }
  }
  async function RetriveEditService() {
    setIsLoading(true);
    try {
      const response = await RetriveServiceEditService({
        serviceId: selectedId,
      });
      //   console.log("selectedId",selectedId);
      // console.log('Raw DB data:', response.data.key_description);
      if (response.status.code === 200) {
        //console.log(response.data)
        setAdjustmentType(response.data.adjustment_type);
        setValue(response.data.introduction);
        setPostUrl(response.data.end_point);
        setServiceName(response.data.service_name);
        setSystemName(response.data.system_name);
        setPreference(response.data.preference);
        setStatusAdd(response.data.status.id);
        setVendorId(Number(response.data.vendor_id));
        setKeyDescription(response.data.key_description || "");
        setServiceValue(response.data.service_value || "");
        setMethod(response.data.method);
        setSelectedCategory(response.data.service_category_id);
        setRequestResponse(response.data.request);
        setFailedResponse(response.data.failed_response);
        setActivationFees(response.data.activation_fee);
        setSuccessResponse(response.data.response);
        setPerHitCost(response.data.per_hit_cost);
        setStatusCode(response.data.skip_status_codes)

        setIsLoading(false);
      }
      // console.log("dataEdt",vendorId);
    } catch (error) {
      setIsLoading(false);
      return error;
    } finally {
      setIsLoading(false);
    }
  }
  function resetFormFields() {
    setAdjustmentType("");
    setValue("");
    setMethod("");
    setPostUrl("");
    setPerHitCost("");
    setServiceName("");
    setSystemName("");
    setPreference("");
    setStatusAdd(null);
    setVendorId(null);
    setKeyDescription("{}");
    setSelectedCategory("");
    setRequestResponse("");
    setFailedResponse("");
    setActivationFees("");
    setSuccessResponse("");
    // onClose();
  }

  function resetUpdateValue() {
    resetFormFields();
    onClose();
  }

  const handleUpdateSerice = async () => {
    setIsLoading(true);
    try {
      if (isAgreementAgreed === false) {
        return showErrorToast("Checked Agrement ");
      }

      const response = await updateApiService({
        skip_status_codes: statusCode?.toString().split(","),
        serviceId: selectedId,
        categoryId: selectedCategory,
        serviceName: serviceName,
        system_name: systemName,
        preference: preference,
        statusAdd: statusAdd,
        vendorId: vendorId ? Number(vendorId) : null,
        keyDescription: keyDescription,
        serviceValue: serviceValue,
        method: method,
        per_hit_cost: perHitCost,
        postUrl: postUrl,
        introduction: value,
        requestResponse: requestResponse,
        failedResponse: failedResponse,
        fees: activationFees,
        adjustment_type: adjustmentType,
        successResponse: successResponse,
      });

      if (response.status.code === 200) {
        onClose();
        showSuccessToast(response.message || "Successfully Update service ");
        setIsLoading(false);
        return;
      }
      if (response.status.code === 422) {
        showErrorToast(response.status.message);
        setIsLoading(false);
        return;
      }
    } catch (error) {
      console.log('err', error);
      
      showErrorToast("Failed to add new service ");
      setIsLoading(false);
      return;
    } finally {
      setIsLoading(false);
    }
  };
  // useEffect(() => {
  //     if (visible === true) {
  //         RetriveEditService();
  //         RetriveServicecategory();
  //         return
  //     }

  // }, [visible])

  // Update useEffect
  useEffect(() => {
    if (visible && selectedId) {
      // Force fresh component every time
      setComponentKey((prev) => prev + 1);
      RetriveServicecategory();
      RetriveEditService(); // Load data after remount
    }
  }, [visible, selectedId]);

  // useEffect(() => {
  //   console.log("failedResponse  +++++++++++++++++++++++", failedResponse);
  //   console.log("type", typeof failedResponse);
  // }, [failedResponse]);

  // useEffect(() => {
  //  console.log(statusCode.toString().split(","));

  // }, [statusCode])
  return (
    <div className="w-[100vw] bg-red-600" style={{ width: "100vw" }}>
      {isLoading && <Loader />}
      <PopMenu
        visible={visible}
        onClose={resetUpdateValue}
        title={"Service Edit Form"}
        className={"overflow-y-scroll min-w-[90vw] z-50 h-[96vh]"}
      >
        <DivTag className="flex flex-wrap p-1 mt-1">
          <SelectWithLabelOption
            DivclassName="w-full md:w-1/4 px-3 md:mb-0"
            label="Select Service Category"
            id="service"
            name="service"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <Option value="#" disabled selected>
              Select Service Category
            </Option>
            {serviceCategoryList && serviceCategoryList.length > 0
              ? serviceCategoryList.map((category, index) => (
                  <Option key={index} value={category.id}>
                    {category?.name}
                  </Option>
                ))
              : ""}
          </SelectWithLabelOption>
          <SelectWithLabelOption
            DivclassName="w-full md:w-1/4 px-3 md:mb-0"
            label="Select Adjustment_type
"
            id="service"
            name="service"
            value={adjustmentType}
            onChange={(e) => setAdjustmentType(e.target.value)}
            required={true}
          >
            <Option value="" disabled selected>
              Select adjustment_type
            </Option>
            <Option value="charge">charge</Option>
            <Option value="commission">commission</Option>
            <Option value="charge_slab">Charge Slab</Option>
          </SelectWithLabelOption>
          <InputWithLabel
            DivclassName="w-full md:w-1/4 px-2 md:mb-0 text-left mb-0 text-white"
            DivTagClassName="absolute z-60 ml-3 mt-16 w-40 bg-white border rounded shadow-md"
            label="Service Name"
            type="text"
            name="service_name"
            placeholder="Enter Service Name..."
            id="service_name"
            value={serviceName}
            onChange={(e) => setServiceName(e.target.value)}
            className="border"
            required={true}
          />
          <InputWithLabel
            DivclassName="w-full md:w-1/4 px-2 md:mb-0 text-left mb-0 text-black"
            DivTagClassName="absolute z-60 ml-3 mt-16 w-40 bg-white border rounded shadow-md"
            label="Post URL"
            type="url"
            name="post_url"
            placeholder="Enter POST URL..."
            id="post_url"
            value={postUrl}
            onChange={(e) => setPostUrl(e.target.value)}
            className="border"
            required={true}
          />

          <InputWithLabel
            DivclassName="w-full md:w-1/4 px-2 md:mb-0 text-left mb-0 text-black"
            DivTagClassName="absolute z-60 ml-3 mt-16 w-40 bg-white border rounded shadow-md"
            label="System Name"
            type="text"
            name="system_name"
            placeholder="Enter System Name..."
            id="system_name"
            value={systemName}
            onChange={(e) => setSystemName(e.target.value)}
            className="border"
            required={true}
          />

          <SelectWithLabelOption
            DivclassName="w-full md:w-1/5 px-3 md:mb-0"
            label="Preference"
            id="preference"
            name="preference"
            value={preference}
            onChange={(e) => setPreference(e.target.value)}
          >
            <Option value="" disabled selected>
              Select Preference{" "}
            </Option>
            <Option className="bg-red-500 text-white" value="None">
              None
            </Option>
            <Option className=" bg-green-400 text-white" value="Recommended">
              Recommended
            </Option>
            <Option
              className="bg-green-700 text-white"
              value="Highly Recommended"
            >
              Highly Recommended
            </Option>
          </SelectWithLabelOption>
          <SelectWithLabelOption
            DivclassName="w-full md:w-1/6 px-3 md:mb-0"
            label="Status"
            value={statusAdd}
            required={true}
            onChange={(e) => setStatusAdd(Number(e.target.value))}
          >
            <Option value={5}>Active</Option>
            <Option value={4}>Inactive</Option>
            <Option value={18}>Deprecated</Option>
            <Option value={19}>CommingSoon</Option>
          </SelectWithLabelOption>

          <SelectWithLabelOption
            DivclassName="w-full md:w-1/5 px-3 md:mb-0"
            label="Vendor"
            value={vendorId}
            onChange={(e) => {
              const val = e.target.value;
              setVendorId(val === "" ? null : Number(val));
            }}
          >
            <Option value="">-- Select Vendor --</Option>
            {vendorList?.map((v) => (
              <Option key={v.id} value={v.id}>
                {v.name}
              </Option>
            ))}
          </SelectWithLabelOption>

          <SelectWithLabelOption
            DivclassName="w-full md:w-1/6 px-3 md:mb-0"
            label="Method"
            id="method"
            name="method"
            value={method}
            onChange={(e) => setMethod(e.target.value)}
            className="border border-blue-600"
            required={true}
          >
            <Option value="" disabled className="text-gray-400">
              Select method
            </Option>

            <Option value="GET" className="text-green-400 text-bold">
              GET
            </Option>
            <Option value="POST" className="text-orange-400 text-bold">
              POST
            </Option>
            <Option value="PUT" className="text-blue-400 text-bold">
              PUT
            </Option>
            <Option value="PATCH" className="text-purple-400 text-bold">
              PATCH
            </Option>
            <Option value="DELETE" className="text-red-400 text-bold">
              DELETE
            </Option>
            <Option value="HEAD" className="text-lime-400 text-bold">
              HEAD
            </Option>
            <Option value="OPTIONS" className="text-pink-400 text-bold">
              OPTIONS
            </Option>
          </SelectWithLabelOption>

          <InputWithLabel
            DivclassName="w-full md:w-1/5 text-black px-2 md:mb-0 text-left mb-0 text-black"
            DivTagClassName="absolute z-60 ml-3 mt-16 w-40 bg-white border rounded shadow-md text-black"
            label="Per Hit Cost"
            type="perHitCost"
            name="perHitCost"
            placeholder="Enter Per Hit Cost..."
            id="perHitCost"
            value={perHitCost}
            onChange={(e) => setPerHitCost(e.target.value)}
            className="border"
            required={false}
          />

          <div className="w-full mt-2 mb-2">
            <div className="grid grid-cols-2">
              {/* <TextAreaWithLabel DivclassName="w-full px-0 md:mb-0 text-left mb-0 text-black text-xs"
                                label="Key Description"
                                type="text"
                                placeholder="Enter Key Description"
                                value={keyDescription}
                                onChange={(e) => setKeyDescription(e.target.value)}
                                class_name='h-32'
                            
                            /> */}
              <UnifiedApiParameterBuilder
                key={componentKey}
                label="API Configuration"
                value={keyDescription || "{}"}
                onChange={(jsonString) => setKeyDescription(jsonString)}
              />

              <div className="pl-4">
                <TextAreaWithLabel
                  DivclassName="w-full px-2 md:mb-0 text-left mb-0 text-black text-xs"
                  label="Service Value"
                  type="text"
                  placeholder="Enter Service Value"
                  value={serviceValue}
                  onChange={(e) => setServiceValue(e.target.value)}
                  class_name="h-32"
                />

            
              </div>
            </div>
          </div>

          <div className="d-flex w-full">
            <div className="flex flex-col my-2 text-xs">
              <label className="block uppercase tracking-wide text-s font-bold mb-1">
                Instruction <span className="text-red-500">*</span>
              </label>
              <ReactQuill
                theme="snow"
                value={value}
                onChange={setValue}
                modules={modules_quill}
                formats={formats}
                placeholder="Enter Instruction here...."
                required={true}
                className="h-40"
              />
            </div>
          </div>
          <div className="flex gap-3 mt-12 w-full">
            {" "}
            {/* w-full on parent */}
            <div className="flex-1">
              {" "}
              {/*  Wrapper div with flex-1 */}
              <JsonFormatter
                label="Request"
                value={requestResponse}
                onChange={setRequestResponse}
                className="h-72"
              />
            </div>
            <div className="flex-1">
              {" "}
              {/* Second wrapper */}
              <JsonFormatter
                label="Success Response"
                value={successResponse}
                onChange={setSuccessResponse}
                className="h-72"
              />
            </div>
          </div>

          <TextAreaWithLabel2
            DivclassName="w-full px-2 md:mb-0 text-left mb-0 text-black text-xs"
            label="faled Response "
            type="text"
            placeholder="Failed Response"
            name="req_sample"
            id="req_sample"
            value={failedResponse}
            onChange={(e) => setFailedResponse(e.target.value)}
            setFailedResponse={(val) =>
              setFailedResponse((prev) => prev + ",\n" + val)
            }
            class_name="h-72"
            required={true}
          />

          <InputWithLabel
            DivclassName="w-full md:w-1/3 px-2 md:mb-0 text-left mb-0 text-black"
            DivTagClassName="absolute z-60 ml-3 mt-16 w-40 handleSearcherbg-white border rounded shadow-md"
            label="Service Price"
            type="number"
            name="post_url"
            placeholder="Enter Price "
            id="post_url"
            value={activationFees}
            onChange={(e) => setActivationFees(e.target.value)}
            className="border"
            required={true}
          />

          <div className="flex mt-5 ml-6 items-center gap-2 ">
            <input
              type="checkbox"
              className="h-5 w-5"
              onChange={() => setIsAgreementAgreed(!isAgreementAgreed)}
            />
            <p className="text-neutral-500 ">I have agreed terms & condition</p>
          </div>

          <Button
            type="submit"
            className="text-center mx-auto text-white bg-blue-700 shadow-lg bg-gradient-to-r mt-3 from-blue-900 via-teal-400 to-purple-900 font-semibold rounded-md px-2 py-1 text-lg hover:bg-red-300"
            onClick={handleUpdateSerice}
          >
            Update
          </Button>
        </DivTag>
      </PopMenu>
    </div>
  );
};

export default UpdatePopUp;

const JsonFormatter = ({ label, value, onChange, className }) => {
  const beautify = async (text) => {
    if (!text?.trim()) return "";
    try {
      const repaired = await jsonrepair(text); // Fixes EVERYTHING!
      return JSON.stringify(JSON.parse(repaired), null, 2);
    } catch {
      return text;
    }
  };

  const onPaste = async (e) => {
    e.preventDefault();
    const text = e.clipboardData.getData("text");
    const formatted = await beautify(text);
    onChange(formatted);
    // Auto-select end
    setTimeout(() =>
      e.target.setSelectionRange(formatted.length, formatted.length),
    );
  };

  const onKeyDown = async (e) => {
    if (e.metaKey || e.ctrlKey) {
      if (e.key === "Enter") {
        e.preventDefault();
        const formatted = await beautify(e.target.value);
        onChange(formatted);
      }
    }
  };

  return (
    <div className="mb-4 w-full">
      <label className="block text-sm font-medium mb-2">
        {label} <span className="text-xs text-gray-500"></span>
      </label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onPaste={onPaste}
        onKeyDown={onKeyDown}
        className={`w-full ${className} p-3 border rounded-lg font-mono text-sm min-h-[200px] resize-vertical focus:ring-2 focus:ring-blue-500 bg-gray-50`}
        placeholder="Paste JSON - auto beautifies!"
        spellCheck={false}
      />
    </div>
  );
};
